import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { orgKnowledgeService } from "@/services/orgKnowledgeService";

export function useOrgDocuments(enabled = true) {
  return useQuery({ queryKey: ["org-knowledge"], queryFn: orgKnowledgeService.list, enabled });
}

export function useOrgJobs(enabled = true) {
  return useQuery({
    queryKey: ["org-knowledge", "jobs"],
    queryFn: orgKnowledgeService.jobs,
    enabled,
    refetchInterval: (query) => {
      const jobs = query.state.data || [];
      return jobs.some((j) => j.status === "pending" || j.status === "running") ? 3000 : false;
    },
  });
}

function useInvalidating(fn, keys, options) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: fn,
    ...options,
    onSuccess: (...args) => {
      keys.forEach((k) => qc.invalidateQueries({ queryKey: k }));
      options.onSuccess?.(...args);
    },
  });
}

export function useUploadDocument(options = {}) {
  return useInvalidating(orgKnowledgeService.upload, [["org-knowledge"]], options);
}
export function useDeleteDocument(options = {}) {
  return useInvalidating(orgKnowledgeService.remove, [["org-knowledge"]], options);
}
export function useBulkGenerate(options = {}) {
  return useInvalidating(orgKnowledgeService.bulkGenerate, [["org-knowledge", "jobs"]], options);
}
